import { render } from "./PositionExample.vue?vue&type=template&id=098f86ba&compiler=vugel"
import script from "./PositionExample.vue?vue&type=script&lang=ts"
export * from "./PositionExample.vue?vue&type=script&lang=ts"
script.render = render

export default script